import { useEffect, useState } from 'react';
import type { InstagramPost } from '@/types';
import { api } from '@/client/lib/api';
import { SectionHeader } from '@/components/SectionHeader';
import { PlayIcon } from '@/components/Icons';
import { track } from '@/client/lib/analytics';
import { BRAND } from '@/config/site';
import { useI18n } from '@/client/i18n/I18nContext';
import { shortAlt } from './shortAlt';

export function InstagramGrid() {
  const { t } = useI18n();
  const [posts, setPosts] = useState<InstagramPost[] | null>(null);

  useEffect(() => {
    // Non-blocking; homepage never waits on Instagram.
    api.instagram().then(setPosts).catch(() => setPosts([]));
  }, []);

  return (
    <section className="section container">
      <SectionHeader
        eyebrow={t('newsletter.eyebrow')}
        title={t('ig.title')}
        action={
          <a
            className="btn btn--ghost"
            href={BRAND.instagramUrl}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => track('instagram_click', { where: 'section_cta' })}
          >
            @{BRAND.instagramHandle}
          </a>
        }
      />
      <div className="ig-grid">
        {(posts ?? Array.from({ length: 6 }).map(() => null)).map((post, idx) =>
          post ? (
            <a
              key={post.id}
              className="ig-item"
              href={post.permalink}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => track('instagram_click', { id: post.id })}
            >
              {post.thumbnailUrl ? (
                <img src={post.thumbnailUrl} alt={shortAlt(post.caption, t('ig.altFallback'))} loading="lazy" />
              ) : (
                <span className="ig-item__placeholder">CARO</span>
              )}
              {post.isReel ? (
                <span className="ig-item__reel">
                  <PlayIcon width={18} height={18} />
                </span>
              ) : null}
            </a>
          ) : (
            <div key={`sk-${idx}`} className="ig-item" aria-hidden />
          ),
        )}
      </div>
    </section>
  );
}
